<template>
  <div class="kye-report-dgkp003" @click="handleClick('cardClick')">
    <div class="dgkp003_main-cell-title">
      <img
        class="dgkp003_main-icon1"
        :src="data.mainIcon1 || mainIcon1"
        @click="handleClick('mainIcon1')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainIcon1', data.mainIcon1]}"
      />
      <div
        class="dgkp003_main-title"
        @click="handleClick('mainTitle')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', data.mainTitle]}"
      >{{ data.mainTitle }}</div>
      <KyeReportCardQuestion
            class="dgkp003_main-icon2"
            :icon="data.mainIcon2"
            :popover="data.popover"
            @click="handleClick('mainIcon2')">
            <slot :name="'tooltip'"></slot>
      </KyeReportCardQuestion>
    </div>
    <div class="dgkp003_main-cell-list">
      <div
        class="dgkp003_main-index-cell"
        v-for="(item, index) in data.list"
        :key="index"
        >
        <div
          class="dgkp003_list-title"
          @click="handleClick('listTitle', index)"
          v-events="{ eventsMap, ignoreEventName, args: ['listTitle', index, item.listTitle]}"
        >{{ item.listTitle }}</div>
        <div
          class="dgkp003_list-index"
          @click="handleClick('listIndex', index)"
          v-events="{ eventsMap, ignoreEventName, args: ['listIndex', index, item.listIndex]}"
        >{{ item.listIndex }}</div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/dgkp001.png'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportDgkp003',
  components: {
    KyeReportCardQuestion
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../style/extend.scss';
.kye-report-dgkp003 {
  background: #FFFFFF;
  border-radius: 4px;
  padding: 16px;
  flex-direction: column;
  cursor: pointer;
  .dgkp003_main-cell-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    .dgkp003_main-icon1 {
      width: 16px;
      height: 16px;
    }
    .dgkp003_main-title {
      color: #333333;
      font-size: 14px;
      font-weight: 600;
    }
    .dgkp003_main-icon2 {
      align-items: center;
    }
  }
  .dgkp003_main-cell-list {
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    .dgkp003_main-index-cell {
      display: flex;
      flex-direction: column;
      gap: 4px;
      flex: 1;
      // margin-right: 36px;
      .dgkp003_list-title {
        color: #666666;
        font-size: 12px;
      }
      .dgkp003_list-index {
        color: #333333;
        font-size: 20px;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/dgkp003/index.vue